<template>
  <div id="agencyComponent">
    <div class="d-md-flex flex-column justify-center align-center flex-row">
      <v-container class="unskew px-10 px-md-0 py-0">
        <v-row>
          <v-col
            class="pa-0"
            cols="12"
            dense
          >
            <h3
              v-if="tenant.company_display_name != null"
              class="whiteText pt-8"
            >
              {{ tenant.company_display_name }}'s <br> Candidate Portal
            </h3>
            <h2
              v-else
              class="whiteText pt-8"
            >
              Select Agency To Login
            </h2>
          </v-col>
        </v-row>
        <v-form
          class="d-flex justify-center"
        >
          <v-row>
            <v-col
              v-if="agencies.length > 5"
              cols="12"
              class="pb-0"
            >
              <v-select
                class="textField"
                :items="agencies"
                item-text="company"
                item-value="agencyUrl"
                filled
                label="Select Agency"
                @change="redirectToAgency($event)"
              />
            </v-col>
            <v-col
              v-else
              cols="12"
              class="pb-0"
            >
              <span
                v-for="agency in agencies"
                :key="agency.company"
              >
                <v-btn
                  class="mb-1"
                  block
                  tile
                  @click="redirectToAgency(agency.agencyUrl)"
                >
                  {{ agency.company }}
                </v-btn>
              </span>
            </v-col>

            <v-col
              v-if="invites.length > 0"
              class="col-12 pa-0 mt-12"
            >
              <h2 class="whiteText">
                Awaiting Agency
              </h2>
            </v-col>
            <v-col
              v-if="invites.length > 5"
              cols="12"
              class="pb-0"
            >
              <v-select
                class="textField"
                :items="invites"
                item-text="company"
                item-value="agencyUrl"
                filled
                label="Select Invite"
                @change="redirectToInvites($event)"
              />
            </v-col>
            <v-col
              v-else
              cols="12"
              class="pb-0"
            >
              <span
                v-for="invite in invites"
                :key="invite.company"
              >
                <v-btn
                  class="mb-1"
                  block
                  tile
                  @click="redirectToInvites(invite.agencyUrl)"
                >
                  {{ invite.company }}
                </v-btn>
              </span>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AgencyComponent',
  props: {
    tenant: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    loading: false,
    agencies: [],
    invites: [],
    passwordResetPrompt: false,
    errors: []
  }),
  computed: {
    //
  },
  created () {
    this.agencies = this.$parent.agencies
    this.invites = this.$parent.invites
    this.passwordResetPrompt = this.$parent.passwordResetPrompt
  },
  methods: {
    redirectToAgency (agencyUrl) {
      var baseUrl = ''
      if (!agencyUrl.startsWith('http')) {
        baseUrl = '//'
      }
      if (this.passwordResetPrompt) {
        window.location.href = baseUrl + agencyUrl + '/change-password'
      } else {
        window.location.href = baseUrl + agencyUrl + '/dashboard'
      }
    },
    redirectToInvites (agencyUrl) {
      var baseUrl = ''
      if (!agencyUrl.startsWith('http')) {
        baseUrl = '//'
      }
      window.location.href = baseUrl + agencyUrl + '/'
    }
  }
}
</script>
<style lang="scss">
@import './resources/sass/variables';
#agencyComponent {
    .v-btn{
        font-size: x-small;
        @media screen and (min-width: 500px) {
            font-size: small;
            marigin-bottom:15px;
        }
        @media screen and (min-width: 1400px) {
            font-size: medium;
            margin-bottom:15px;
        }
    }
    .error--text{
        color: $agencyColorDark !important
    }
    .whiteText{
        color: white;
        &.v-btn{
            font-size: x-small;
            @media screen and (min-width: 600px){
                font-size: small;
            }
            @media screen and (min-width: 1400px){
                font-size: initial;
            }
        }
    }
    .v-input__slot {
        background: $agencyColorLight;
    }
    .unskew{
        text-align: center;
        transform: skewY(-10deg);
        color: white;
        min-height: 500px;
        @media screen and (min-width: 960px) {
            max-width: 65%;
            transform: skewX(15deg);
            margin: 1rem 1rem;
            padding: 1rem 1rem;
        }
    }
}
</style>
